export default {
      id: "resize-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "icons.svg#resize",
      toString: function () {
        return this.url;
      }
    }